import * as React from "react";
import MUIBox from "@mui/material/Box";

const Box = ({ children, component, ...rest }) => {
  return (
    <MUIBox component={component} {...rest}>
      {children}
    </MUIBox>
  );
};

export default Box;
